const AddonNames = {
  LIVENESS_DETECTION: "Liveness Detection",
  OCR_ENHANCEMENT: "OCR Enhancement",
  NEURAL_FRAUD_AI: "AI Fraud Detection",
  AML_DETECTION: "AML Detection",
  WEBHOOK_NOTIFICATIONS: "Webhook Notifications",
  WEB3_INTEGRATION: "Web3 Integration",
  PROOF_OF_ADDRESS: "Proof Of Address",
  NFC_VERIFICATION: "NFC Verification",
};

export { AddonNames };
